
import {defineComponent, onMounted, PropType, reactive} from 'vue';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {MigrationStatus} from "@dex/squeeze-client-ts";
import useSqueezeStore from "@/apps/squeeze/store";
import {TableListSettings, TableSettings} from "@/util/TableSettings";
import {ClientManager} from "@/singletons/ClientManager";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import {useRoute} from "vue-router";

export default defineComponent({
	name: "MigrationsList",
	components: {DataTable, Column},
	props: {
		migrations: {
			type: Array as PropType<MigrationStatus[]>,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['openEntryDialog'],
	setup(props, {emit}) {
		const {t} = useI18n();
		const toast = useToast();
		const route = useRoute();

		/** Vuex Store */
		const store = useSqueezeStore();

		/** User API endpoint */
		const userApi = ClientManager.getInstance().squeeze.user;

		/** Current table list pagination */
		const tableListPagination = reactive<TableListSettings>({});

		const openEntryDialog = () => {
			emit("openEntryDialog", {password: ''});
		}

		onMounted(() => {
			tableListPagination.pageSize = TableSettings.getTableListPagination(store, route.name);
		});

		/** Triggered when page is changed */
		const onChangePage = (event: { page: number; rows: number }) => {
			tableListPagination.pageSize = event.rows;
			TableSettings.saveTableListPagination(t, toast, store, userApi, route.name, event.rows);
		}

		return { tableListPagination, openEntryDialog, onChangePage };
	},
});

